import type { ReactNode } from "react";

export function Panel({ children, primary }: { children: ReactNode; primary?: boolean }) {
  return <section className={primary ? "panel-primary" : "panel"}>{children}</section>;
}
